import { Component, ElementRef, inject, OnInit } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { CallbackComponent } from '@shared-components/callback/callback.component';
import { ComponentHeaderComponent } from '@shared-components/component-header/component-header.component';

@Component({
  selector: 'fourd-callback-button',
  imports: [CallbackComponent, ComponentHeaderComponent],
  templateUrl: './callback-button.component.html',
  host: {
    '[class]': 'componentClass',
    //'(click)': 'toggleCallback($event)',
  },
  providers: [...BaseComponent.componentProviders],
})
export class CallbackButtonComponent extends BaseComponent implements OnInit {

  private elementRef = inject(ElementRef);

  phoneNumberDialling: string;
  phoneNumberDisplay: string;

  initialLoadComplete: boolean = false;
  showCallOptions: boolean = false;
  showCallback: boolean = false;

  ivrCallBackEnabled = false;

  private readonly attributeNamePhoneNumberDialling: string = "phoneNumberDialling";
  private readonly attributeNamePhoneNumberDisplay: string = "phoneNumberDisplay";

  constructor() {
    super("CallbackButtonComponent");

    let phoneNumberDiallingContent = this.elementRef?.nativeElement?.getAttribute(this.attributeNamePhoneNumberDialling);
    //console.log(phoneNumberDiallingContent);
    let phoneNumberDisplayContent = this.elementRef?.nativeElement?.getAttribute(this.attributeNamePhoneNumberDisplay);
    //console.log(phoneNumberDisplayContent);

    if (phoneNumberDiallingContent) {
      this.phoneNumberDialling = this.jsonObjectTryParseFromAttribute(phoneNumberDiallingContent, this.attributeNamePhoneNumberDialling);
    }

    if (phoneNumberDisplayContent) {
      this.phoneNumberDisplay = this.jsonObjectTryParseFromAttribute(phoneNumberDisplayContent, this.attributeNamePhoneNumberDisplay);
    }
    //console.log(this.ivrCallBackEnabled);

    this.ensureConfigLoaded(() => {
      const config = this.config();
      if (config) {
        //console.log(this.config);
        this.ivrCallBackEnabled = config?.IvrCallBackEnabled;
        //console.log(this.ivrCallBackEnabled);
      }

      this.ensureMemberLoaded(() => {
      });
    });
  }

  ngOnInit() {
    //console.log("ngOnInit");
    this.initialLoadComplete = true;
  }

  toggleTest(): void {
    //console.log("toggleTest");
  }

  toggleCallOptions(event: Event): void {
    this.handleClickEvent(event);
    this.showCallOptions = !this.showCallOptions;
  }

  toggleCallback(event: Event): void {
    this.handleClickEvent(event);
    this.showCallback = !this.showCallback;
  }

  openCallback(event: Event): void {
    this.handleClickEvent(event);
    this.showCallback = true;
  }

  closeCallback(): void {
    this.showCallback = false;
  }

  onCloseCallOptions(): void {
    this.showCallOptions = false;
  }

  onCancelCallback(eventData: boolean): void {
    this.showCallback = false;
  }

}
